<script setup lang="ts">
import type { CmsElementNewsletterBanner } from "~/composables/useCustom";

// Define props
const props = defineProps<{
  content: CmsElementNewsletterBanner;
}>();

const { mainText, headlineText, logo } = props.content?.data || {};
</script>

<template>
  <div :class="`cms-element-${props.content.type}`" class="bg-red-bg px-4">
    <div class="container mx-auto relative py-12 sm:py-20">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Left Side: Title and Image -->
        <div class="text-left flex items-start justify-start flex-col">
          <NuxtImg
            v-if="logo.media"
            :src="logo.media.url"
            :alt="logo.media.alt ?? 'logo'"
            :format="logo.media.mimetype"
            class="mb-0 md:mb-7 w-32 md:w-48"
            width="192px"
            height="60px"
          />
          <div class="title">
            <h3
              v-if="headlineText"
              class="hidden md:block h3-font leading-tight text-white text-2xl md:text-3xl lg:text-4xl font-bold max-w-full md:max-w-[80%]"
            >
              {{ headlineText }}
            </h3>
          </div>
        </div>

        <!-- Right Side: Paragraph and Subscription Form -->
        <div class="text-left w-full lg:w-[489px]">
          <p v-if="mainText" class="text-sm md:text-lg text-white mb-9">
            {{ mainText }}
          </p>
          <FormsSwNewsletterForm />
        </div>
      </div>
    </div>
  </div>
</template>
